<template>
<div class="row">
    <v-card color="grey lighten-4" flat>
        <v-layout row wrap>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title> İstek Listesi</v-toolbar-title>
                </v-toolbar>
            </v-flex>
        </v-layout>
    </v-card>

<content>

        <v-flex pa-1 xs12 sm12 md12 >
            <v-card>
                <v-list>
                    <v-list-tile>
                        <v-flex xs12 sm10 md10>
                            {{SonucSayi}} {{this.$t('Number-of-Records-Found')}}
                        </v-flex>
                        <v-spacer></v-spacer>

                        <v-flex xs12 sm3 md3>
                            <v-select hide-details="" :items="siralamatipiitems" v-model="RequestList.Paging.Filter" color="grey darken-1" item-text="text" item-value="value" :label="$t('Sort-By')">
                            </v-select>
                        </v-flex>
                    </v-list-tile>
                </v-list>
            </v-card>
        </v-flex>


            <v-flex pa-1 xs12 sm12 md12 >
                <v-layout row wrap>

                    <v-flex pb-2 v-for="(item,index) in isteklistesi" v-bind:key="index" xs12 sm12 md12>

                        <v-hover>
                            <v-card flat="" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`" width="100%">

                                <v-list>
                                    <v-layout row wrap>

                                        <v-flex xs12 sm9 md12>
                                            <v-layout row wrap>

                                                <v-flex pl-4 xs12 sm12 md3>
                                                    <div class="font-weight-light title">
                                                        <v-icon color="primary">business</v-icon> Acente :
                                                    </div>

                                                    <div class="font-weight-light subheading">
                                                        {{item.CompanyName}}
                                                    </div>
                                                </v-flex>

                                                <v-flex pl-4 xs12 sm12 md3>
                                                    <div class="font-weight-light title">
                                                        <v-icon color="primary">face</v-icon> {{$t('Customer')}} :
                                                    </div>
                                                    <div class="font-weight-light subheading">
                                                        {{item.Name}} {{item.LastName}}
                                                    </div>
                                                </v-flex>

                                                <v-flex pl-4 xs12 sm12 md3>
                                                    <div class="font-weight-light title">
                                                        <v-icon color="primary">event</v-icon> İstek Tarih :
                                                    </div>
                                                    <div class="font-weight-light subheading">
                                                        {{item.RequestDate | dateformat}}
                                                    </div>
                                                </v-flex>

                                                <v-flex pl-4 xs12 sm12 md2>
                                                    <div class="font-weight-light title">
                                                        <v-icon color="primary">bar_chart</v-icon> İstek Durum :
                                                    </div>
                                                    <div v-if="item.Status==0" class="font-weight-light subheading">
                                                        Teklif Verilebilir
                                                    </div>
                                                    <div v-if="item.Status==1" class="font-weight-light subheading">
                                                        <v-flex v-if="item.RequestType==2">
                                                            Saç Tutmaz
                                                        </v-flex>
                                                        <v-flex v-if="item.RequestType==0 || item.RequestType == 1">
                                                            Onay Bekleniyor
                                                        </v-flex>

                                                    </div>
                                                    <div v-if="item.Status==2" class="font-weight-light subheading">
                                                        Onaylandı
                                                    </div>
                                                    <div v-if="item.Status==3" class="font-weight-light subheading">
                                                        Kullanıcı Reddetti
                                                    </div>
                                                </v-flex>

                                                <v-flex v-if="item.Status==0" pl-4 xs12 sm12 md1>
                                                    <v-btn icon @click="idgonder(item.ID,item.Status)">
                                                        <v-icon x-large="" color="primary">
                                                            search
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                                <v-flex v-if="item.Status==1" @click="idgonder(item.ID,item.Status)" pl-4 xs12 sm12 md1>
                                                    <v-flex v-if="item.RequestType==2">
                                                        <v-btn icon>
                                                            <v-icon x-large="" color="red">
                                                                cancel
                                                            </v-icon>
                                                        </v-btn>
                                                    </v-flex>
                                                    <v-flex v-if="item.RequestType==0 || item.RequestType == 1">
                                                        <v-btn icon>
                                                            <v-icon x-large="" color="primary">
                                                                hourglass_bottom
                                                            </v-icon>
                                                        </v-btn>
                                                    </v-flex>
                                                </v-flex>
                                                <v-flex v-if="item.Status==2" @click="idgonder(item.ID,item.Status)" pl-4 xs12 sm12 md1>
                                                    <v-btn icon>
                                                        <v-icon x-large="" color="green">
                                                            check
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                                <v-flex v-if="item.Status==3" @click="idgonder(item.ID,item.Status)" pl-4 xs12 sm12 md1>
                                                    <v-btn icon>
                                                        <v-icon x-large="" color="red">
                                                            cancel
                                                        </v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                </v-list>
                            </v-card>
                        </v-hover>
                    </v-flex>

                </v-layout>
            </v-flex>
</content>

    <template v-if="vmodelpagination">
        <div class="text-xs-center">
            <v-container>
                <v-layout justify-center>
                    <v-flex xs8>
                        <v-pagination :disabled="paginationDisabled" color="info" v-model="sayfalama" :length="pagenumber"></v-pagination>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
    </template>

    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
    </v-snackbar>

</div>
</template>

<script>
import auth from "@/api/auth.js"
import helpers from "@/components/app/customcomp/helpers.js"
import tarihcomp from "@/components/app/customcomp/tarihim.vue"

export default {
    data() {
        return {
            isteklistesi: [],
            SonucSayi: 0,
            text1: '',
            snackbar: false,
            loading: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            pagenumber: 1,
            sayfalama: 1,
            paginationDisabled: false,
            vmodelpagination: false,
            RequestList: {
                CompanyId: null,
                Paging: {
                    PageNumber: 1,
                    DataCount: 20,
                    Filter: null
                },
            },
            siralamatipiitems: [{
                text: 'Tarih Artan',
                value: 'Date'
            }, {
                text: 'Tarih Azalan',
                value: 'DateDesc'
            }],
        }
    },
    components: {
        tarihcomp
    },
    beforeMount: beforeMount,
    watch: {
        sayfalama(value) {
            this.IstekList(value)
        },
        'RequestList.Paging.Filter': function (val) {
            this.IstekList()
        }
    },
    methods: {
        idgonder(val, status) {

            var url = '#/coper/clinista/acenteistekislem/id?' + '&RequestID=' + val + '&Status=' + status

            window.open(url, '_self')

        },
        IstekList: IstekList
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
    }
}

function beforeMount() {
    this.drawer = false
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.RequestList.CompanyId = credentials.MusteriID

    var params = this.RequestList
    this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/RequestList', params, {
        headers: {
            'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                .HOTELRUNNERUSERPASS)
        }
    }).then((response) => {
        this.isteklistesi = response.body

        this.SonucSayi = response.body[0].TotalCount

        if (response.body[0].TotalCount > 20) {
            this.vmodelpagination = true;
            this.pagenumber = response.body[0].TotalPage;
        }
    }, (response) => {
        this.text1 = "Hatalı Kayıt."
        this.snackbar = true
    })
}

function IstekList(sayfano) {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.RequestList.Paging.PageNumber = sayfano
    this.RequestList.CompanyId = credentials.MusteriID
    var params = this.RequestList

    this.$http.post(auth.CLINISTA_API_URL + 'api/Clinista/RequestList', params, {
        headers: {
            'Authorization': 'Basic ' + window.btoa(auth.HOTELRUNNERUSERNAME + ':' + auth
                .HOTELRUNNERUSERPASS)
        }
    }).then((response) => {
        this.isteklistesi = response.body

        this.SonucSayi = response.body[0].TotalCount

        if (response.body[0].TotalCount > 20) {
            this.vmodelpagination = true;
            this.pagenumber = response.body[0].TotalPage;
        }
    }, (response) => {
        this.text1 = "Hatalı Kayıt."
        this.snackbar = true
    })
}
</script>
